import React from 'react'
import Routes from 'routes'
import { Switch, Route, Redirect } from 'react-router-dom'
import { scrollTop } from 'helpers'
import { AppView, AppContainer, AppHeader, AppContent } from 'components/layout'
import ChapterIntroView from './ChapterIntroView'
import ChapterAspectView from './ChapterAspectView'

class ChaptersRootView extends React.Component {
  componentDidMount() {
    scrollTop()
  }

  render() {
    return (
      <AppView name="Chapters">
        <AppHeader />

        <AppContent>
          <AppContainer>
            <Switch>
              <Route path={Routes.to('chapters')} exact  render={() => <Redirect to={Routes.to('home')} />} />
              <Route path={Routes.to('chapter')} exact   component={ChapterIntroView} />
              <Route path={Routes.to('aspect')} exact    component={ChapterAspectView} />
            </Switch>
          </AppContainer>
        </AppContent>
      </AppView>
    )
  }
}

export default ChaptersRootView



// WEBPACK FOOTER //
// ./src/components/views/chapters/ChaptersRootView.js